module.exports = __webpack_public_path__ + "img/google_workplace.248daec0.jpg";